<nav aria-label="breadcrumb" role="navigation">
  <ol class="breadcrumb">
    <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs; let l = last">
      <a [routerLink]="breadcrumb[0]" *ngIf="breadcrumb[2] && !l">{{ breadcrumb[1] }}</a>
      <a [href]="breadcrumb[0]" *ngIf="!breadcrumb[2] && !l">{{ breadcrumb[1] }}</a>
      <span *ngIf="l" class="text-muted">{{ breadcrumb[1] }}</span>
    </li>
  </ol>
</nav>
